// src/services/api.js
import axios from 'axios';
import { refreshToken } from './tokenService';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + '/api';
const WEBSOCKET_BASE_URL = process.env.REACT_APP_API_BASE_URL;

let isRefreshing = false;
let pendingRequests = [];

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // <<< отправляем/получаем куки автоматически
});

// Подкладываем accessToken в заголовок каждого запроса
api.interceptors.request.use(config => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function logoutUser() {
  localStorage.removeItem('accessToken');
  window.location.href = '/login';
}

// Обрабатываем очередь отложенных запросов
function processQueue(err, token = null) {
  pendingRequests.forEach(p => {
    if (err) p.reject(err);
    else    p.resolve(token);
  });
  pendingRequests = [];
}

api.interceptors.response.use(
  response => response.data,
  async error => {
    const { response, config } = error;
    const status = response?.status;
    const url    = config.url || '';

    // Если это 401 на /auth/refresh — сразу кикать
    if (status === 401 && url.endsWith('/auth/refresh')) {
      // logoutUser();
      return Promise.reject(error);
    }

    // Если 401, и ещё не пробовали:
    if (status === 401 && !config._retry) {
      config._retry = true;
     let newToken;
      try {
       newToken = await refreshToken();  // 👈 единый запрос
       localStorage.setItem('accessToken', newToken);
       config.headers.Authorization = `Bearer ${newToken}`;
       return api(config);
      } catch (refreshErr) {

        logoutUser();
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);

// Упрощённые обёртки
api.get    = (url, opts = {}) => api.request({ url, method: 'GET',    ...opts });
api.post   = (url, data, opts = {}) => api.request({ url, method: 'POST',   data, ...opts });
api.put    = (url, data, opts = {}) => api.request({ url, method: 'PUT',    data, ...opts });
api.delete = (url, opts = {}) => api.request({ url, method: 'DELETE', ...opts });

export default api;
